import { idnr } from '@navikt/fnrvalidator';
import * as yup from 'yup';

import errorText from './validationTexts';

/* Main Applicant */
export const mainApplicantSchema = yup.object().shape({
    email: yup.string().trim().email(errorText.emailInvalid).required(errorText.emailRequired),

    phone: yup
        .string()
        .trim()
        .typeError(errorText.phoneLength)
        .min(8, errorText.phoneLength)
        .max(8, errorText.phoneLength)
        .length(8, errorText.phoneLength)
        .required(errorText.phoneLength),

    livingConditionCode: yup.string().required(errorText.livingConditionRequired),

    rentalFee: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .number()
                .integer(errorText.rentalFeeRequired)
                .positive(errorText.rentalFeeRequired)
                .typeError(errorText.rentalFeeRequired)
                .min(0, errorText.rentalFeeRequired)
                .max(9999999, errorText.rentalFeeLength)
                .required(errorText.rentalFeeRequired);
        }
        return yup.mixed().notRequired();
    }),

    employmentConditionCode: yup.string().required(errorText.employmentRequired),

    grossIncome: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .number()
                .integer(errorText.grossIncomeRequired)
                .positive(errorText.grossIncomeRequired)
                .typeError(errorText.grossIncomeRequired)
                .min(0, errorText.grossIncomeRequired)
                .max(1000000000, errorText.grossIncomeMax)
                .required(errorText.grossIncomeRequired);
        }
        return yup.mixed().notRequired();
    }),

    // totalDebt: yup
    //     .number()
    //     .integer(errorText.totalDebtRequired)
    //     .typeError(errorText.totalDebtRequired)
    //     .min(0, errorText.totalDebtRequired)
    //     .max(1000000000, errorText.totalDebtMax)
    //     .required(errorText.totalDebtRequired),

    totalDebt: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .number()
                .integer(errorText.totalDebtRequired)
                .typeError(errorText.totalDebtRequired)
                .min(0, errorText.totalDebtRequired)
                .max(1000000000, errorText.totalDebtMax)
                .required(errorText.totalDebtRequired);
        }
        return yup.mixed().notRequired();
    }),

    tradeIn: yup.boolean().required(),

    tradeInDebt: yup.number().when('tradeIn', {
        is: true,
        then: (schema) =>
            schema
                .typeError(errorText.tradeInDebtRequired)
                .min(0, errorText.tradeInDebtRequired)
                .max(9999999, errorText.tradeInDebtLength)
                .required(errorText.tradeInDebtRequired),
    }),
});

/* Co Applicant */
export const coApplicantSchema = yup.object().shape({
    hasCoApplicant: yup.boolean(),

    confirmAddress: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .boolean()
                .required(errorText.coApplicantSameAddress)
                .oneOf([true], errorText.coApplicantSameAddress);
        }
        return yup.mixed().notRequired();
    }),

    ssn: yup.string().when('hasCoApplicant', {
        is: true,
        then: (schema) =>
            schema
                .trim()
                .test('ssnValidation', errorText.ssn, (value) => {
                    if (value !== undefined) {
                        return idnr(`${value}`).status !== 'invalid';
                    }
                    return false;
                })
                .min(11, errorText.ssn)
                .max(11, errorText.ssn)
                .required(errorText.ssn),
    }),

    email: yup.string().trim().email(errorText.emailInvalid).required(errorText.emailRequired),

    phone: yup
        .string()
        .trim()
        .typeError(errorText.phoneLength)
        .min(8, errorText.phoneLength)
        .max(8, errorText.phoneLength)
        .length(8, errorText.phoneLength)
        .required(errorText.phoneLength),

    livingConditionCode: yup.string().required(errorText.livingConditionRequired),

    rentalFee: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .number()
                .integer(errorText.rentalFeeRequired)
                .positive(errorText.rentalFeeRequired)
                .typeError(errorText.rentalFeeRequired)
                .min(0, errorText.rentalFeeRequired)
                .max(9999999, errorText.rentalFeeLength)
                .required(errorText.rentalFeeRequired);
        }
        return yup.mixed().notRequired();
    }),

    employmentConditionCode: yup.string().required(errorText.employmentRequired),

    grossIncome: yup.lazy((value) => {
        if (value !== undefined) {
            return yup
                .number()
                .integer(errorText.grossIncomeRequired)
                .positive(errorText.grossIncomeRequired)
                .typeError(errorText.grossIncomeRequired)
                .min(0, errorText.grossIncomeRequired)
                .max(1000000000, errorText.grossIncomeMax)
                .required(errorText.grossIncomeRequired);
        }
        return yup.mixed().notRequired();
    }),

    totalDebt: yup
        .number()
        .integer(errorText.totalDebtRequired)
        .typeError(errorText.totalDebtRequired)
        .min(0, errorText.totalDebtRequired)
        .max(1000000000, errorText.totalDebtMax)
        .required(errorText.totalDebtRequired),

    tradeIn: yup.boolean().required(),

    tradeInDebt: yup.number().when('tradeIn', {
        is: true,
        then: (schema) =>
            schema
                .typeError(errorText.tradeInDebtRequired)
                .min(0, errorText.tradeInDebtRequired)
                .max(9999999, errorText.tradeInDebtLength)
                .required(errorText.tradeInDebtRequired),
    }),
});

/* Feedback */
export const feedbackSchema = yup.object().shape({
    feedbackMessage: yup.string().required(errorText.feedbackMessageRequired).max(500, errorText.feedbackMessageMax),
});
